// BNB Address
const BNB_ADDRESS = '0x45C7287F897B3A79Cd3f6e4F14B4CE568f023bD5'

export { BNB_ADDRESS }
